// SettingsSection.js
import React, { useState, useEffect, useRef } from 'react';
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Button,
  Badge,
  Input
} from "reactstrap";
import { withTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';

import { BottomSheet } from 'react-spring-bottom-sheet';
import LevelEditor from './components/LevelEditor';

import { ChevronRight, ChevronDown } from 'lucide-react';

import placeholder_image from "assets/images/info/card-placeholder-medium.png";

import axiosInstance from "utils/axiosInstance";


const SettingsSection = ({ t, myInfoProfile }) => {

  const navigate = useNavigate();

  const [levelEditorExpanded, setLevelEditorExpanded] = useState(false);
  const [bottomSheetOpen, setBottomSheetOpen] = useState(false);

  //--------------------------------------------------
  // Return
  //--------------------------------------------------

  return (

    <div className="settings-section-container">
      {/* Mobile Layout */}
      <div className="d-block d-md-none">
        <div className="d-flex flex-column align-items-center justify-content-center"
          style={{ minHeight: "160px" }}
        >
          <div className="d-flex w-100"
            style={{
              paddingLeft: "35px",
              paddingRight: "35px",
              paddingBottom: "10px",
              fontSize: "16px", 
              fontWeight: "500",
              cursor: "pointer"
            }}
            onClick={()=>{setLevelEditorExpanded(!levelEditorExpanded)}}
          >
            <div className="d-flex w-100 justify-content-between"
              style={{
                border: "1px solid #c8c8c8", 
                padding: "8px 10px", 
                borderRadius: "10px", 
                backgroundColor: "#f6f6f6"
              }}
            >
              <p className="mb-0 me-1">等級設定</p>
              <div>
                {levelEditorExpanded ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
              </div>
            </div>
          </div>

          {levelEditorExpanded && (
            <LevelEditor 
              myInfoProfile={myInfoProfile} 
            />
          )}

          <div className="d-flex justify-content-center w-100" style={{ marginTop: "30px" }}>
            <Button
              color="danger"
              className="text-center"
              style={{ minWidth: "70%" }}
              onClick={() => navigate('/logout')}
            >
              {t("登出")}
            </Button>
          </div>

          {/*
          <Button onClick={() => setBottomSheetOpen(true)} style={{ margin: '2rem' }}>
            Open Bottom Sheet
          </Button>
          */}
        </div>
      </div>

      {/* Desktop Layout */}
      <div className="d-none d-md-block">
        <div className="settings-desktop-container">
          <div className="settings-header">
            <h4 className="settings-title">設定</h4>
          </div>
          
          <div className="settings-content">
            <div className="level-settings-section">
              <div className="level-settings-header"
                onClick={()=>{setLevelEditorExpanded(!levelEditorExpanded)}}
              >
                <h5 className="mb-0">等級設定</h5>
                <div className="level-toggle-icon">
                  {levelEditorExpanded ? <ChevronDown size={20} /> : <ChevronRight size={20} />}
                </div>
              </div>

              {levelEditorExpanded && (
                <div className="level-editor-desktop">
                  <LevelEditor 
                    myInfoProfile={myInfoProfile} 
                  />
                </div>
              )}
            </div>

            <div className="logout-section">
              <Button
                color="danger"
                size="lg"
                className="logout-button"
                onClick={() => navigate('/logout')}
              >
                {t("登出")}
              </Button>
            </div>
          </div>
        </div>
      </div>

      <BottomSheet open={bottomSheetOpen} onDismiss={() => setBottomSheetOpen(false)}>
        <div style={{ padding: '20px 20px 80px 20px' }}>
          <h3>Bottom Sheet Content</h3>
          <p>This is a mobile-friendly bottom sheet.</p>
          <Button onClick={() => setBottomSheetOpen(false)}>Close</Button>
        </div>
      </BottomSheet>
    </div>

  );
};

export default withTranslation()(SettingsSection);


